// WebHeader.jsx 

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/authContext';
import { useTranslation } from 'react-i18next';
// import LanguageSwitcher from '../../locales/LanguageSwitcher';
import WebMenu from './WebMenu';
import UserMenu from './UserMenu';
// import AVIcon from '../../components/icons/AllVoicedIcons';
import LoginModal from '../../components/modals/web-modals/LoginModal';
import SignUpModal from '../../components/modals/web-modals/SignUpModal';

function WebHeader() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();

  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isSignUpModalOpen, setSignUpModalOpen] = useState(false);

  const openLoginModal = () => setLoginModalOpen(true);
  const closeLoginModal = () => setLoginModalOpen(false);
  const openSignUpModal = () => setSignUpModalOpen(true);
  const closeSignUpModal = () => setSignUpModalOpen(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const expirationDate = new Date(tokenData.exp * 1000);
      if (expirationDate < new Date()) {
        logout();
        alert(t('session_expired'));
      }
    }
  }, [logout, t]);

  return (
    <header className="web-header">
      <div className="web-header-content">
        {/* 🔹 Esquerra: menú mòbil + logo */}
        <div className="header-left">
          <WebMenu mode="mobile" />
          <Link to="/" className="brand">
            <img
              src="/images/logo/isotype-positive.svg"
              alt="All-Voiced Logo"
              style={{ width: '40px', height: 'auto' }}
            />
          </Link>
        </div>

        {/* 🔹 Centre: menú desktop */}
        <div className="header-center desktop-menu">
          <WebMenu mode="desktop" />
        </div>

        {/* 🔹 Dreta: idioma + usuari */}
        <div className="header-right">
         {/* <LanguageSwitcher />*/}
          {user ? (
            <UserMenu />
          ) : (
            <div className="auth-actions">
            <button
              onClick={openLoginModal}
              className="login-signup-button"
            >
              {t('login', 'Log in')}
            </button>

            <button
              onClick={openSignUpModal}
              className="login-signup-button signup"
            >
              {t('signup', 'Sign up')}
            </button>
          </div>
          )}
        </div>
      </div>

      {/* 🔹 Modals */}
      <LoginModal
        isOpen={isLoginModalOpen}
        onRequestClose={closeLoginModal}
        openSignUpModal={openSignUpModal}
      />
      <SignUpModal
        isOpen={isSignUpModalOpen}
        onRequestClose={closeSignUpModal}
        openLoginModal={openLoginModal}
      />
    </header>
  );
}

export default WebHeader;